export default __webpack_public_path__ + "static/media/Small Gas Grenade.8268319a.PNG";